var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00363 6C6.1994 6 6.38067 5.92332 6.51843 5.79553L11.797 1.03514C11.9275 0.920126 12 0.773161 12 0.607027C12 0.261979 11.7027 -2.04617e-06 11.3112 -1.97771e-06C11.1299 -1.94602e-06 10.9486 0.0638958 10.8181 0.178912L6.00363 4.52396L1.18187 0.178914C1.05136 0.0638976 0.884592 -1.54667e-07 0.688822 -1.20437e-07C0.304532 -5.3246e-08 4.58062e-08 0.261981 1.06136e-07 0.607029C1.35184e-07 0.773163 0.0725077 0.920128 0.203021 1.03514L5.48157 5.79553C5.63384 5.92971 5.80061 6 6.00363 6Z",
    fill: "#393E42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/arrow-down-black.6faf714dec9e08281bae2fa608457d0c.svg";
export { ForwardRef as ReactComponent };